import { useEffect, useRef } from "react";
import styled from "styled-components";

type VideoPlayProps = {
  filePath: string;
  autoPlay?: boolean;
  muted?: boolean;
  width?: number;
  currentTime?: number;
  loop?: boolean;
};

const VideoPlay = ({
  filePath,
  autoPlay,
  muted,
  width,
  currentTime,
  loop,
}: VideoPlayProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const mutedValue: boolean = typeof muted !== "undefined" ? muted : true;
  const widthValue: number = typeof width !== "undefined" ? width : 250;
  useEffect(() => {
    if (videoRef.current) {
      if (currentTime) {
        videoRef.current.currentTime = currentTime;
      }
    }
  }, []);

  return (
    <DivPlay>
      <video
        ref={videoRef}
        controls
        width={widthValue}
        autoPlay={autoPlay}
        muted={mutedValue}
        loop={loop}
      >
        <source src={filePath} type="video/mp4" />
        Download the
        <a href={filePath}>MP4</a>
        video.
      </video>
    </DivPlay>
  );
};

const DivPlay = styled.div`
  display: flex;
`;

export default VideoPlay;
